import React from 'react';
import classNames from 'classnames';
import { Icon } from '../Icon/Icon';
/**
 * Bronson PlayButton component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-play-button.html
 * @constructor
 */
export function PlayButton({ className, iconClassName, pauseVideoLabel, playVideoLabel, testId, ...otherProps }) {
    const buttonClassNameList = classNames('c-play-button', className).trim();
    const iconClassNameList = classNames('c-play-button__icon', iconClassName).trim();
    return (React.createElement("button", { className: buttonClassNameList, type: "button", "data-testid": testId, "data-play-button-label-play": `${playVideoLabel || 'Play Video'}`, "data-play-button-label-pause": `${pauseVideoLabel || 'Pause Video'}`, ...otherProps },
        React.createElement(Icon, { className: iconClassNameList, name: "play", viaCss: true })));
}
